var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileuser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Profile",
    transform: "translate(-4732 -793)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6080",
    "data-name": "Rectangle 6080",
    width: 24,
    height: 24,
    transform: "translate(4732 793)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun-profile-1079819",
    transform: "translate(4721.49 788.36)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34820",
    "data-name": "Path 34820",
    d: "M33.394,16.418A5.389,5.389,0,1,0,28,11.029a5.389,5.389,0,0,0,5.394,5.389Zm0-9.824a4.431,4.431,0,1,1-4.435,4.435,4.431,4.431,0,0,1,4.435-4.435Z",
    transform: "translate(-11.018 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34821",
    "data-name": "Path 34821",
    d: "M22.376,54.88c-5.717,0-8.866,1.948-8.866,5.49,0,2.157,3.812,3.8,8.866,3.8s8.866-1.634,8.866-3.8C31.242,56.826,28.093,54.88,22.376,54.88Zm0,8.332c-4.661,0-7.907-1.5-7.907-2.842,0-3.745,4.3-4.531,7.907-4.531s7.907.786,7.907,4.531c0,1.342-3.237,2.839-7.907,2.839Z",
    transform: "translate(0 -37.441)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileuser);
export default __webpack_public_path__ + "static/media/profileuser.505fd5f84d55d8a6d59edb1e4772ddc0.svg";
export { ForwardRef as ReactComponent };